import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { LoadingDots } from "../Components/LoadingDots";
import expenseService from "../Services/expense";
import expensesHeadService from "../Services/expensesHead";
import accountService from "../Services/accountService";
import moment from "moment";
import Dropdown from "../Components/Dropdown";
import SecondaryButton from "../Components/SecondaryButton";
import { FiPlus } from "react-icons/fi";

const AddExpense = () => {
  const navigate = useNavigate();
  const [responseError, setResponseError] = useState("");
  const [expensesHead, setExpensesHead] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    title: "",
    amount: "",
    account: "",
    note: "",
    date: "",
    voucher: "",
  });

  const [errors, setErrors] = useState({
    title: false,
    amount: false,
    account: false,
    note: false,
    date: false,
    voucher: false,
  });

  const [regex, setRegex] = useState({
    title: /.{1,50}$/,
    amount: /.{1,50}$/,
    account: /.{1,50}$/,
    note: /.{1,50}$/,
    date: /.{1,50}$/,
    voucher: /.{1,50}$/,
  });

  useEffect(() => {
    expensesHeadService.fetchAllExpensesHead().then((res) => {
      console.log(res);
      setExpensesHead(res.expenseHeads);
    });
    accountService.fetchAllActiveAccounts().then((res) => {
      console.log(res);
      setAccounts(res.accounts);
    });
  }, []);

  const handleChange = (v, n) => {
    if (n === "date" && v > moment().format("YYYY-MM-DD")) {
      toast.error("Cannot select future date", { id: "1" });
      return;
    }
    if (n === "amount" && v < 0) {
      return;
    }
    setResponseError("");
    setData((d) => ({ ...d, [n]: v }));
    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }
  };

  const handleSubmit = () => {
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      setLoading(true);
      expenseService.create(data).then((res) => {
        if (res.responseCode === 201) {
          toast.error(res.message, { id: "3" });
          setLoading(false);
          return;
        }
        setLoading(false);
        toast.success("Expenses Added Successfully", { id: "2" });
        navigate("/expenses");
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <main className="mx-10 mt-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <p className="font-bold text-3xl text-secondary text-center mt-10">
        Add Expense
      </p>

      <div className="mt-10 px-80">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-2 md:gap-4">
          <div>
            <label className="primary-label">Expense Head</label>
            <Dropdown
              selected={data.title}
              placeholder="Select Head"
              onChange={(value) => handleChange(value, "title")}
              options={expensesHead.map((expense) => ({
                label: expense.head_title,
                value: expense.id,
              }))}
            />
          </div>
          <div>
            <label className="primary-label">Account</label>
            <Dropdown
              selected={data.account}
              placeholder="Select Account"
              onChange={(value) => handleChange(value, "account")}
              options={accounts.map((acc) => ({
                label: `${acc.account_name} - ${acc.account_title}`,
                value: acc.id,
              }))}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-4 mt-4">
          <div>
            <label className="primary-label">Voucher Type</label>
            <Dropdown
              selected={data.voucher}
              placeholder="Select Voucher"
              onChange={(value) => handleChange(value, "voucher")}
              options={[
                { label: "CASH PAYMENT VOUCHER", value: "CPV" },
                { label: "BANK PAYMENT VOUCHER", value: "BPV" },
              ]}
            />
          </div>
          <div>
            <label className="primary-label">Amount</label>
            <input
              value={data.amount}
              name="amount"
              type="number"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["amount"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className="primary-label">Date</label>
            <input
              value={data.date}
              type="date"
              name="date"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="date"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["date"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className="primary-label">Note</label>
            <input
              value={data.note}
              name="note"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["note"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
        </div>
        <div className="flex items-center justify-center mt-10">
          <SecondaryButton
            text={loading ? <LoadingDots /> : "Add"}
            Icon={FiPlus}
            color="!px-16"
            onClick={() => handleSubmit()}
          />
        </div>
      </div>
    </main>
  );
};

export default AddExpense;
